import ItemsListVue from '@/views/sm/items-list/items-list.vue';

const basePath = '/sm/items-list';
const role = 'sm'; // 角色身份

export const SM_ITEMS_LIST_INDEX = 'sm-items-list-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ItemsListVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_ITEMS_LIST_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/items-list/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
